
  import EmptyStateEntry from '@/ui/pages/EmptyStateEntry';
  import { defineComponent } from 'vue';
  import { hasPermission, Permissions } from '@/ui/auth/auth';
  import { Button } from '@/ui/components/Button';

  export default defineComponent({
    components: {
      EmptyStateEntry,
      Button,
    },
    setup() {
      const canConductOpenInspections = hasPermission(Permissions.CONDUCT_OPEN_INSPECTIONS);

      return {
        route: { name: 'inspectionCreateFromTemplate' },
        canConductOpenInspections,
      };
    },
  });
